export const banks_noprogramm = [14]